export const destroyerQuotes = {
    preMend: {
        id: 0,
        lines: [
            "(What have we done...)",
            "(We've won...but at what cost)",
            "(Surely, there is another way...)"
        ]
    }
}